import React from 'react'
import { isFlagOn } from 'utils/featureFlags'
import {
  RouteContentGetter,
  RouteContentType,
} from 'layers/content/v2/Hocs/RouteContentGetter'
import { CurriculumRouteContentGetter } from 'layers/content/v3/Hocs/CurriculumRouteContentGetter'

export const CURRICULUM_CONTENT_FLAG = 'feature_LEARN-26260-curriculum-content'

export { RouteContentType }

/**
 * Flag-switched HOC factory. Returns a component that checks the flag
 * at render time, delegating to v3 CurriculumRouteContentGetter when on
 * or the original v2 RouteContentGetter when off.
 *
 * Drop-in replacement for RouteContentGetter — same signature.
 */
export function FlaggedRouteContentGetter(Component, options) {
  const CurriculumWrapped = CurriculumRouteContentGetter(Component, options)
  const LegacyWrapped = RouteContentGetter(Component, options)

  function FlaggedComponent(props) {
    if (isFlagOn([CURRICULUM_CONTENT_FLAG])) {
      return <CurriculumWrapped {...props} />
    }
    return <LegacyWrapped {...props} />
  }

  FlaggedComponent.displayName = `FlaggedRouteContentGetter(${Component.displayName ||
    Component.name ||
    'Component'})`

  return FlaggedComponent
}
